import {cloneDeep, debounce} from 'lodash';

export function clone(value:any) {
  return cloneDeep(value);
}

export function debounceTime(callback: (value: any) => void, waitMilliseconds: number)  {
  return debounce(callback, waitMilliseconds);
}
